
const cores = {
    
	fundo_degrade_inicio: '#ce4493',
    fundo_degrade_fim: '#704a98',
	
	barra_status: '#704a98',

    fundo_claro: "#ffffff",
    fundo_escuro: "#333",
    
    fonte_clara: "#f8f9fa",
    fonte_escura: "#373737",
    fonte_erro: '#ff0000',


	azul: '#05a9cd',
	vermelho: '#ff0000',
	roxo:'#704a98',
    
	cinza_claro: '#eeeeee',
	cinza_medio: '#dfdfdf',
	
	verde: '#008000',

	preto: '#000000'
  };
  

export default cores;
